/**
 * Cuánto falta para poder reenviar el código por correo (bloque 1 · C6b).
 *
 * Por marca de tiempo y no por un contador que se decrementa: en el móvil la persona cambia a
 * la app del correo, el navegador congela los intervalos de la pestaña en segundo plano, y un
 * contador restado de uno en uno volvería mostrando una espera que ya pasó.
 *
 * 60 s es una espera de pantalla, no un tope: el servidor ya limita a 5 envíos por correo cada
 * 15 minutos (`sendVerificationCode.js`). Esto evita gastar esos 5 en un minuto de impaciencia.
 *
 * CommonJS y pura para probarla desde `functions/__tests__`.
 */
const ESPERA_REENVIO_MS = 60 * 1000;

/** Segundos enteros que faltan (0 = ya se puede). */
function segundosParaReenviar(disponibleEnMs, ahoraMs) {
  if (!Number.isFinite(disponibleEnMs) || !Number.isFinite(ahoraMs)) return 0;
  return Math.max(0, Math.ceil((disponibleEnMs - ahoraMs) / 1000));
}

module.exports = { ESPERA_REENVIO_MS, segundosParaReenviar };
